export default {"src":"/_next/static/media/company.351ffa81.svg","height":513,"width":513};